const forbiddenCharacters = /[$<>/\\]/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateTextInput = (text, field, blankAllowed=false) => {
	if (!blankAllowed && (typeof text === 'string' || text === undefined || text === null) && (!text || text.trim() === '')) {
		return `${field} cannot be blank`;
	} else if (typeof text !== 'string' && (text !== undefined || text !== null)) {
		return `${field} must be a string`;
	} else if (text.length <= 3 && text.length > 0) {
		return `${field} entry must be more at least 3 characters long`;
	} else if (forbiddenCharacters.test(text)) {
		return `${field} contain invalid characters`;
	}

  	return null;
};

export const validateEmail = (email) => {
	if (email.trim().length === 0) return 'The email cannot be blank';
    if (email.trim() && !emailRegex.test(email)) {
    	return `Please enter a valid email address`;
    }

 	return null;                
};

export const validateContactForm = (formData) => {
	let errors = {};
	const fields = Object.keys(formData);
	
	for (const field of fields) {
		if (!field || field.trim() === '') {
			errors[field] = 'Field cannot be blank';
		}

		if (field === 'email') {
			const error = validateEmail(formData[field]);
			if (error) {
				errors[field] = error;
			}
		} else {
			const error = validateTextInput(formData[field])
			if (error) {
				errors[field] = error;
			}
		}
	}

	return errors;
};